export enum EventLoadType
{
    Summarized = 1,
    ActiveLots = 2,
    Full = 3
}
